import type { FC } from "react";
import { ASSISTANT_AVATAR } from "@/theme/tokens";

const { ACCESSORY } = ASSISTANT_AVATAR;

/** A tilted witch hat. The tip stays inside the viewBox padding, so it never clips at small sizes. */
export const WitchHat: FC = () => (
	<g transform="rotate(-9 60 16)">
		{/* Brim first, so the cone and its band sit in front of the brim's far edge. */}
		<ellipse cx={60} cy={17} rx={40} ry={7} fill={ACCESSORY.WITCH_HAT} />
		<path d="M36 16 C44 2 54 -6 70 -10 C64 -2 66 6 84 16 Z" fill={ACCESSORY.WITCH_HAT} />
		<path d="M38.5 11 L78.5 11 L84 16 L36 16 Z" fill={ACCESSORY.WITCH_HAT_BAND} />
	</g>
);

/** A gnarled stem with a leaf and a curling vine; the body draws the ribs and the carved face. */
export const PumpkinStem: FC = () => (
	<>
		<path
			d="M58 15 C55 8 58 2 56 -3 C60 -2 64 0 66 -4"
			fill="none"
			stroke={ACCESSORY.PUMPKIN_STEM}
			strokeWidth={6}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path d="M50 6 C44 2 40 6 43 9 C45 11 48 9 46 7" fill="none" stroke={ACCESSORY.PUMPKIN_STEM} strokeWidth={1.8} strokeLinecap="round" />
		<path d="M64 2 C74 -6 84 -2 86 4 C78 8 70 8 64 2Z" fill={ACCESSORY.PUMPKIN_LEAF} />
	</>
);

/** A high two-tone collar standing up behind the head. Drawn before the body, so only its points show. */
export const VampireCollar: FC = () => (
	<>
		{["M10 106 L-4 34 L40 70 Z", "M110 106 L124 34 L80 70 Z"].map((collar) => (
			<path key={collar} d={collar} fill={ACCESSORY.VAMPIRE_COLLAR} />
		))}
		{["M14 100 L3 46 L34 72 Z", "M106 100 L117 46 L86 72 Z"].map((lining) => (
			<path key={lining} d={lining} fill={ACCESSORY.VAMPIRE_LINING} />
		))}
	</>
);

/** A widow's peak and two small fangs under the smile; the collar is `VampireCollar`, behind the body. */
export const Vampire: FC = () => (
	<>
		<path d="M22 40 C30 22 46 14 60 28 C74 14 90 22 98 40 C92 22 78 12 60 12 C42 12 28 22 22 40Z" fill={ACCESSORY.VAMPIRE_HAIR} />
		<path d="M53.5 77.6 L55.5 83 L57.5 78.6Z M62.5 78.6 L64.5 83 L66.5 77.6Z" fill={ACCESSORY.FANG} />
	</>
);
